import { Box, Typography, useTheme } from '@mui/material';
import { Rating } from '@care/react-component-lib';
import { Caregiver } from '@/types';

const CaregiverCardFront = ({
  card,
  isVisible,
  isFading,
}: {
  card: Caregiver;
  isVisible: boolean;
  isFading: boolean;
}) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="caregiver-card-front"
      sx={{
        backgroundImage: `url(${card.photo})`,
        backgroundSize: 'cover',
        padding: theme.spacing(3, 0, 4, 2),
        color: theme.palette.text.contrast,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'absolute ',
        top: 0,
        left: 0,
        ...(!isVisible && {
          opacity: 0,
        }),
        ...(isFading && {
          opacity: isVisible ? 0 : 1,
          transition: 'opacity 0.5s ease-in-out',
        }),
      }}>
      <Box>
        <Typography variant="accentHeadline1">{card.name}</Typography>
        <Typography variant="h3">{card.headline}</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Rating value={card.rating} precision={0.5} readOnly size="small" />
        <Typography variant="h5">{card.experience}</Typography>
      </Box>
    </Box>
  );
};

export default CaregiverCardFront;
